//
//
//
//
//
//

import xlogin from "../components/xlogin.vue"
export default{
	components:{
		xlogin
	}
}



// WEBPACK FOOTER //
// ./src/views/login.vue